import { useEffect } from "react";
import cn from "app/utils/classnames";
import IconClose from "app/icons/IconClose";
import Header from "app/ui/Header";

interface FullScreenPanelProps extends React.HTMLAttributes<HTMLDivElement> {
  heading: string;
  headingClassName?: string;
  closeOverlay?: boolean;
  onClose?: () => void;
}

export default function FullScreenPanel({
  heading,
  headingClassName,
  className,
  onClose,
  children,
  ...props
}: FullScreenPanelProps) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div
      className={cn(
        "flex h-full w-full grow bg-white md:items-center md:justify-center",
        className
      )}
      {...props}
    >
      <div className="flex h-full grow flex-col gap-6 shadow-xl md:h-auto md:max-h-full md:min-h-[50vh] md:max-w-xl md:border md:border-black lg:h-[clamp(min(calc(100vh-80px),600px),60vh,calc(100vh-80px))] lg:justify-start px-5 pb-5">
        <div className="flex h-10 items-center justify-end px-0">
          <button
            className="flex h-10 w-10 items-center justify-end cursor-pointer"
            onClick={() => {
              onClose?.();
            }}
          >
            <IconClose />
          </button>
        </div>
        <Header className={headingClassName}>{heading}</Header>
        <div className="overflow-y-auto">{children}</div>
      </div>
    </div>
  );
}
